import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
import biryaniHero from "@/assets/biryani-branded-watermark.jpg";
import bawarchiLogo from "@/assets/bawarchi-logo.png";

interface HeroProps {
  onOrderClick: () => void;
}

const Hero = ({ onOrderClick }: HeroProps) => {
  return (
    <section className="relative min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src={biryaniHero}
          alt=""
          width={1920}
          height={1080}
          fetchPriority="high"
          loading="eager"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div 
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(to right, rgba(251, 246, 240, 0.95) 0%, rgba(251, 246, 240, 0.85) 50%, rgba(251, 246, 240, 0.4) 100%)'
          }}
        />
      </div>
      
      <div className="container relative z-10">
        <div className="max-w-2xl">
          <div className="flex items-center gap-4 mb-6">
            <img 
              src={bawarchiLogo} 
              alt="Bawarchi 149" 
              width={96}
              height={96}
              loading="eager"
              fetchPriority="high"
              className="h-20 w-20 sm:h-24 sm:w-24 animate-in fade-in-0 zoom-in-95 duration-500" 
            />
            <div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground mb-2 animate-in fade-in-0 slide-in-from-bottom-4 duration-700">
                Bawarchi 149 <span className="text-primary">Express</span>
              </h1>
              <p className="text-lg text-muted-foreground animate-in fade-in-0 slide-in-from-bottom-4 duration-700 delay-100">
                One Dish. Perfect Every Time.
              </p>
              <p className="text-md font-semibold text-primary/90 animate-in fade-in-0 slide-in-from-bottom-4 duration-700 delay-150">
                No Burps Assured
              </p>
            </div>
          </div>
          
          <div className="bg-card/90 backdrop-blur-sm rounded-2xl p-8 shadow-lg border animate-in fade-in-0 slide-in-from-bottom-4 duration-700 delay-200">
            <h2 className="text-3xl font-bold text-foreground mb-2">
              Hyderabadi Bawarchi Chicken Biryani
            </h2>
            <p className="text-4xl font-bold text-primary mb-4">
              ₱149 Only!
            </p>
            <p className="text-muted-foreground mb-6">
              Authentic aromatic biryani made fresh daily with the finest ingredients
            </p>
            <Button size="lg" className="gap-2 text-lg px-8" onClick={onOrderClick}>
              Order Now <ArrowRight className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
